import { Component } from 'react';
import { useParams } from 'react-router-dom';
import { Empty, Spin } from 'antd';
import { getDensityImageUrl } from '../../configs/imageAssets';

const WithDensity = (props) => {
    let params = useParams();
    return <Density {...props} params={params} />
}

class Density extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gene: this.props.params.gene,
            loading: true,
            imageError: false
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params.gene !== this.props.params.gene) {
            this.setState({
                gene: this.props.params.gene,
                loading: true,
                imageError: false
            });
        }
    }

    handleImageLoad = () => {
        this.setState({
            loading: false
        });
    }

    handleImageError = () => {
        this.setState({
            loading: false,
            imageError: true
        });
    }

    render() {
        const { gene, imageError } = this.state;

        const imageUrl = getDensityImageUrl(gene);

        return (
            <Spin spinning={this.state.loading} className='gene-contain'>
                {imageError ? (
                    <Empty description="No density image available" />
                ) : (
                    <img src={imageUrl} alt="density plot" width="100%" onLoad={this.handleImageLoad} onError={this.handleImageError} />
                )}
            </Spin>
        )
    }
}

export default WithDensity
